import { Directive, InjectionToken, Input, HostBinding } from '@angular/core';
import { isNullOrUndefined } from './objectUtils';
import { TranslateService } from '@ngx-translate/core';
import { CommonDataPipe } from './CommonData/CommonDataPipe';

@Directive({
    selector: '[dropdownTitle]',
    standalone: false
})
export class DropdownTitleDirective {

  @HostBinding('attr.title')
  public get dropdownTitle() { return this.getTitleDesc() };
  
  @Input("dropdownTitle")
  dropdownTitleConfig: DropdownTitleConfig;

  constructor(private translate : TranslateService) {
  }

  getTitleDesc() {
    if (!isNullOrUndefined(this.dropdownTitleConfig.dimensions) && !isNullOrUndefined(this.dropdownTitleConfig.value)) {
      var commonDataPipe = new CommonDataPipe();
      return commonDataPipe.transform(this.dropdownTitleConfig.value, this.dropdownTitleConfig.dimensions, "code", "desc");
    }
    else {
        return this.translate.instant("Generic.DropdownPlaceholder");
    }
  }
 
}

interface DropdownTitleConfig {
  value: any,
  dimensions :  models.DimensionVM[]
}
